/**
 * To enable the view use data-view="form". Please note that the form view needs to have is root on a form element.
 * example:
 * <form class="component" data-view="form"></form>
 */
(function (ws) {
    'use strict';
    ws.views.accessLevel = ws.views.form.extend({

        events: {
            'change input.primary': 'primaryState',
            'change input.secondary': 'secondaryState',
            'change input': 'clearErrors'
        },

        /**
         * Initialize
         */
        initialize: function() {
            this.$primary = this.$('.primary-view');
            this.$secondary = this.$('.secondary-view');
            this.$primaryJob = this.$('input[name=primaryJobFunction]');
            this.$accessLevel = this.$('input[name=accessLevel]');

            // define event aggregation
            this.eventAgg = globals.eventAgg;

            // Listen for errors
            this.eventAgg.on('accessLevelError', this.errorHandler.bind(this));
        },

        /**
         * Primary State
         * @param {Object} e
         */
        primaryState: function (e) {
            const isCustomerChecked = e.currentTarget.value === 'customer';

            // toggle secondary
            this.$secondary.toggle(isCustomerChecked)
                .find('input').prop('checked', false);

            // Set value for the hidden input
            const checkedValue = isCustomerChecked ? '' : e.currentTarget.value;
            this.setValue(checkedValue);

            /*const isNewPartner = e.currentTarget.value === 'ProspectCustomerUserAccess';
            if (isNewPartner) {
                $('.globalCustomerVarParent').show();
            } else {
                $('.globalCustomerVarParent').hide();
                $('input[name="globalVarCustomer"]').prop('checked', false);
            }*/

        },

        /**
         * Secondary State
         * @param {Object} e
         */
        secondaryState: function (e) {
            // Set value for the hidden input
            const checkedValue = e.currentTarget.value;
            this.setValue(checkedValue);
        },

        /**
         * Set the value of the hidden input.
         *
         * @param {string} checkedValue
         */
        setValue: function (checkedValue) {
            this.$primaryJob.val(checkedValue);
            this.eventAgg.trigger('selectPrimaryJobFunction', checkedValue);
        },

        /**
         * Handle Error
         */
        errorHandler: function () {
            if (this.$el.is(':visible')) {
                return (function () {
                    return this.$accessLevel.is(':checked') ? this.$secondary : this.$primary;
                }.bind(this))().addClass('error');
            }
        },

        /**
         * Clear Errors
         */
        clearErrors: function () {
            this.$('.error').removeClass('error');
        }

    });
})(westcon);
